import { NumberInput } from "@angular/cdk/coercion";
import { CustomerContactPersonModel, CustomerModel, TourEmailModel, TourModel, UserCustomerModel } from "@core/services/api.service";


export class GetCustomerListAction {
    static readonly type = '[Customers] Load Customer list';
}

export class GetCustomerListSuccessAction {
    static readonly type = '[Customers] Load Customer list Success';

    constructor(public payload: { customers: CustomerModel[] }) { }
}

export class GetCustomerListFailAction {
    static readonly type = '[Customers] Load Customer list Fail';
}
//------------------------------------------------------------------

export class LinkUserAction {
    static readonly type = '[UserCustomers] Link User';

    constructor(public userId: string | undefined, public customerId: number[]) { }
}

export class LinkUserSuccessAction {
    static readonly type = '[UserCustomers] Link User Success';

    constructor(public payload: { userCustomer: UserCustomerModel }) { }
}

export class LinkUserFailAction {
    static readonly type = '[UserCustomers] Link User Fail';
}

//----------------------------------------------------------------
export class GetCustomersByUserIdAction {
    static readonly type = '[UserCustomersList] Load Customer list';

    constructor(public userId: string | undefined) { }
}

export class GetCustomersByUserIdSuccessAction {
    static readonly type = '[UserCustomersList] Load Customer list Success';

    constructor(public payload: { userCustomers: UserCustomerModel[] }) { }
}

export class GetCustomersByUserIdFailAction {
    static readonly type = '[UserCustomersList] Load Customer list Fail';
}

//----------------------------------------------------------------
export class GetCurrentUserCustomersByUserIdAction {
    static readonly type = '[CurrentUserCustomersList] Load Current User Customer list';

    constructor(public userId: string | undefined) { }
}

export class GetCurrentUserCustomersByUserIdSuccessAction {
    static readonly type = '[CurrentUserCustomersList] Load Current User Customer list Success';

    constructor(public payload: { userCustomers: UserCustomerModel[] }) { }
}

export class GetCurrentUserCustomersByUserIdFailAction {
    static readonly type = '[CurrentUserCustomersList] Load Current User Customer list Fail';
}
//--------------------------------------------------------------------
export class AddCustomerContactPersonAction {
    static readonly type = '[CustomerContactPerson] Add Customer Contact Person';

    constructor(public regNumber: string, public tourId: number) { }
  }

  export class AddCustomerContactPersonSuccessAction {
    static readonly type = '[CustomerContactPerson] Add Customer Contact Person Success';

    constructor(public payload: { custContact: TourModel }) { }
  }

  export class AddCustomerContactPersonFailAction {
    static readonly type = '[CustomerContactPerson] Add Customer Contact Person Fail';
  }

//------------------------------------------------------------------------------
export class GetCustomerContactPersonAction {
    static readonly type = '[CustomerContactPerson] Get Customer Contact Person Success';
}

export class GetCustomerContactPersonSuccessAction {
    static readonly type = '[CustomerContactPerson] Get Customer Contact Person Success Success';

    constructor(public payload: { customersContacts: CustomerContactPersonModel[] }) { }
}

export class GetCustomerContactPersonFailAction {
    static readonly type = '[CustomerContactPerson] Get Customer Contact Person Success Fail';
}
//-------------------------------------------------------------------------------------
export class DeleteCustomerContactPersonAction {
    static readonly type = '[CustomerContactPerson] Delete Customer Contact Person';

    constructor(public id: number) { }
  }

  export class DeleteCustomerContactPersonSuccessAction {
    static readonly type = '[CustomerContactPerson] Delete Customer Contact Person Success';

    constructor(public payload: { custContact: TourModel }) { }
  }

  export class DeleteCustomerContactPersonFailAction {
    static readonly type = '[CustomerContactPerson] Delete Customer Contact Person Fail';
  }

//------------------------------------------------------------------------------

export class EditCustomerContactPersonAction {
    static readonly type = '[CustomerContactPerson] Edit Customer Contact Person';

    constructor(public tourId: number, public email: TourEmailModel[]) { }
  }

  export class EditCustomerContactPersonSuccessAction {
    static readonly type = '[CustomerContactPerson] Edit Customer Contact Person Success';

    constructor(public payload: { tour: TourModel }) { }
  }

  export class EditCustomerContactPersonFailAction {
    static readonly type = '[CustomerContactPerson] Edit Customer Contact Person Fail';
  }

//------------------------------------------------------------------------------

  export class UpdateCarrierContactEmailAction {
    static readonly type = '[CarrierContact] Update Carrier Contact Email';

    constructor(public email: string, public tourId: number) { }
  }

  export class UpdateCarrierContactEmailSuccessAction {
    static readonly type = '[CarrierContact] Update Carrier Contact Email Success';

    constructor(public payload: { tour: TourModel }) { }
  }

  export class UpdateCarrierContactEmailFailAction {
    static readonly type = '[CarrierContact] Update Carrier Contact Email Fail';
  }

  //------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
export class DeleteEmailAction {
  static readonly type = '[DeleteEmail] Delete Customer Contact Person';

  constructor(public id: number) { }
}

export class DeleteEmailSuccessAction {
  static readonly type = '[DeleteEmail] Delete Customer Contact Person Success';
}

export class DeleteEmailFailAction {
  static readonly type = '[DeleteEmail] Delete Customer Contact Person Fail';
}
